import { useSelector } from 'react-redux'
import get from 'lodash/get'

/**
 * "Map State to Props" but with useSelector Hook
 * For non-filterInfo variables
 */
export function useStateProps() {
  return useSelector((state) => ({
    activeTabId: state?.activeTabId,
    time: state?.timeFilter || [],
    timeDefaults: get(state, 'filterInfo.defaults.TIME', []),
    lastReset: state?.filterInfo?.lastReset,
    timebands: state?.filterInfo?.values?.[`timebands${state?.activeTabId}`],
    timeFilter: state?.timeFilter,
  }))
}
